export default __webpack_public_path__ + "static/media/24t.6fba812d.jpg";